export const AuthKey = process.env.REACT_APP_AUTH_TOKEN_KEY